import { render, staticRenderFns } from "./moreContent.vue?vue&type=template&id=725705dc&lang=pug&"
import script from "./moreContent.vue?vue&type=script&lang=js&"
export * from "./moreContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports